[
    {
        "title": "Does it work in any country?",
        "content": "Yes, EventLive works globally. Viewers can join from any country."
    },
    {
        "title": "Will I have a recording of my event?",
        "content": "Yes, the app saves a 1080p full quality recording to your device's photo gallery as you stream. It also saves the recording on our servers for on-demand viewing and downloading after the event."
    },
    {
        "title": "Can I buy now and stream from a different device later?",
        "content": "Yes, you can sign in to the EventLive app on any device with your email and password. You can then stream live on the day of the event."
    },
    {
        "title": "When should I invite my guests?",
        "content": "Invite guests now so they are notified ahead of your event. They will also be notified when you go live, so it won't distract from your day."
    },
    {
        "title": "Can I pause and resume streaming?",
        "content": "Yes, you can pause and resume streaming as often as needed. Cover ceremonies, speeches, receptions, etc. Guests will be automatically notified when you resume streaming. The videos will be merged into one recording."
    },
    {
        "title": "Can I stream over 4G/5G or WiFi?",
        "content": "You can use either mobile data or WiFi to stream. Do a free test to see which internet connection works best at your location."
    },
    {
        "title": "How much data does the app use?",
        "content": "The app uses about 1 GB of data per hour of streaming."
    },
    {
        "title": "What internet speed is recommended for streaming?",
        "content": "A consistent minimum upload speed of 10 Mbps is recommended. The app adapts streaming quality if the connection becomes too slow or inconsistent."
    },
    {
        "title": "Can I reschedule or cancel an event?",
        "content": "Yes, you can reschedule for free or cancel and keep your payment for a future event."
    },
    {
        "title": "How long can guests access the event recording after it ends?",
        "content": "Guests can watch the replay for the time you choose: 1 month, 1 year or 10 years. You can extend it later."
    },
    {
        "title": "Do I need to mute guests?",
        "content": "No, it is a one-way stream so guests cannot see or hear each other. They can leave guestbook messages, participate in live chat, etc."
    },
    {
        "title": "Can I see who joined the stream?",
        "content": "Yes, you can view the list of guests who joined, were invited by email, signed the guestbook, subscribed for notifications, etc. You can also require guests to provide their name and email to view the complete guest list if desired."
    },
    {
        "title": "Can I stream from a GoPro, camera, laptop?",
        "content": "Yes, you can use third party software like OBS or Vmix or hardware encoders. EventLive provides streaming details like server URL and stream key for use with these. See our help articles for setup instructions. We recommend using our app when possible for ease of use. You can switch to the app if issues arise with third party software/hardware."
    },
    {
        "title": "Can I print my guestbook?",
        "content": "Yes, you can export your guestbook (including pictures) as a formatted PDF to print. This option is available on your download page."
    },
    {
        "title": "Can I embed the stream elsewhere?",
        "content": "Yes, we provide embed codes to customize and embed just the video or video plus guestbook on other sites."
    },
    {
        "title": "Can I add links or files to my event page?",
        "content": "Yes, you can add unlimited links and upload files to your event page."
    },
    {
        "title": "Can I customize my event page?",
        "content": "Yes, you can upload images, slideshows, add welcome messages, links, documents, etc. to personalize it."
    },
    {
        "title": "Can I password protect my event page?",
        "content": "Yes, although pages are private by default."
    },
    {
        "title": "What if someone misses the live event?",
        "content": "Guests can watch the recording from the beginning anytime after joining. Live streams will take them directly to the current live point."
    },
    {
        "title": "What equipment do I need?",
        "content": "Just an Android/iOS device (smartphone/tablet). We recommend a tripod for stability. A wireless microphone can also improve sound quality."
    }
]